export var AddonName = 'STORYBOOK_ADDON_DESIGNS';
export var PanelName = AddonName + '/panel';
export var Events = {
    UpdateConfig: AddonName + '/update_config',
};
export var ParameterName = 'design';
